import { useTranslation } from 'react-i18next'

import { useDateLimits, useScreen } from '../../../../../hooks'
import { DatePicker } from '../../../../DateTime'
import { FormikField } from '../../../../Formik'
import { CONTRACT_FORM_FIELD_NAME_START_DATE } from '../../../Contract.constants'

function StartDateField() {
  const { t } = useTranslation()

  const { maxDate, minDate } = useDateLimits()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      Component={DatePicker}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Contract.StartDateLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      maxValue={maxDate}
      minValue={minDate}
      name={CONTRACT_FORM_FIELD_NAME_START_DATE}
      placeholder={t('Contract.DatePlaceholderKey')}
    />
  )
}

export default StartDateField
